import React from 'react'
import styled from '@emotion/styled'
import Banner1 from './banner1.jpg'
import Banner2 from './banner2.jpg'
import Loader from './loader.gif'
import LogoNormal from './maxxia-logo.png'
import LogoSmall from './logo-small.svg'
import LogoWhite from './logo-transparent-bg.png'
import UserTestimonial1 from './icon-testimonial-user-1.jpg'
import UserTestimonial2 from './icon-testimonial-user-2.jpg'
import UserTestimonial3 from './icon-testimonial-user-default.png'

const imagesMap = {
  Banner1,
  Banner2,
  Loader,
  LogoNormal,
  LogoSmall,
  LogoWhite,
  UserTestimonial1,
  UserTestimonial2,
  UserTestimonial3,
}

export const Image = (props) => {
  const imageName = props.imageName
  const height = props.height
  const width = props.width

  const CustomImage = styled.img`
    label: CustomImage;
    height: ${height ? height + 'px' : 'auto'};
    width: ${width ? width + 'px' : 'auto'};
  `

  return <CustomImage {...props} src={imagesMap[imageName]} />
}
